// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pin-notice {
  font-size: var(--font-normal);
  display: block;
  margin: 0 auto 24px auto;
  text-align: center;
}

.personal-info-wrapper {
  margin-bottom: 32px;
}

.button-wrapper {
  margin-top: 32px;
}

.danger-notice.small {
  font-size: var(--font-small);
}`, "",{"version":3,"sources":["webpack://./src/app/modals/profile-completion-modal/profile-completion-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,4BAAA;AACF","sourcesContent":[".pin-notice {\n  font-size: var(--font-normal);\n  display: block;\n  margin: 0 auto 24px auto;\n  text-align: center;\n}\n\n.personal-info-wrapper {\n  margin-bottom: 32px;\n}\n\n.button-wrapper {\n  margin-top: 32px;\n}\n\n.danger-notice.small {\n  font-size: var(--font-small);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
